/**
 * Tech Stack Data - Braian's Technologies & Tools
 * Organized by category
 */

export const techStack = {
  // Backend Technologies
  backend: [
    "Symfony",
    "PHP 8+",
    "Doctrine ORM",
    "Laravel",
    "Node.js",
    "Python",
    "Django",
    "Flask",
    "REST APIs",
    "GraphQL"
  ],

  // Frontend Technologies
  frontend: [
    "Vue.js",
    "Pinia",
    "React",
    "TypeScript",
    "JavaScript ES6+",
    "Tailwind CSS",
    "HTML5/CSS3",
    "EasyAdmin",
    "Responsive Design"
  ],

  // DevOps & Infrastructure
  devops: [
    "Docker",
    "Lando",
    "Ubuntu/Debian",
    "Nginx",
    "PM2",
    "Linux Servers",
    "CI/CD",
    "SSL/TLS (Certbot)",
    "Multi-domain Setup"
  ],

  // Databases & Storage
  data: [
    "MySQL/MariaDB",
    "PostgreSQL",
    "MongoDB",
    "Redis",
    "MinIO/S3",
    "Object Storage",
    "Database Optimization"
  ],

  // Messaging & Async
  messaging: [
    "RabbitMQ",
    "Message Queues",
    "Async Processing",
    "Workers"
  ],

  // CMS & Legacy
  cms: [
    "Drupal 7",
    "WordPress",
    "Custom CMS"
  ],

  // Tools & Practices
  tools: [
    "Git/GitHub",
    "Jira",
    "Scrum/Agile",
    "Slack/Discord",
    "Figma",
    "Lucidchart",
    "VS Code",
    "Postman"
  ],

  // Security & Auth
  security: [
    "OAuth2",
    "SSO",
    "JWT",
    "CORS",
    "Security Audits",
    "Data Protection"
  ]
};

// Proficiency levels (optional, for future use)
export const proficiencyLevels = {
  expert: ["Symfony", "Doctrine", "PHP", "Vue.js", "Docker", "Linux"],
  proficient: ["Node.js", "React", "MySQL", "PostgreSQL", "Nginx", "DevOps"],
  competent: ["Python", "Django", "MongoDB", "RabbitMQ", "CI/CD"]
};

// Years of experience per category
export const experienceYears = {
  backend: "5+ years",
  frontend: "5+ years",
  devops: "4+ years",
  databases: "5+ years"
};

export default techStack;
